export default {"src":"/_next/static/media/quote_right.4693da8d.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};